import React from "react";
import { zaokr } from "../../../functions/utilities.js";

const MieszkaniecDaneWodaRozliczenieStany = props => {
    
    const { procent, odczyty } = props;

    return (
        <table className="tabela stany">
            <tbody>
                <tr>
                    <td rowSpan={2}>

                    </td>
                    <td colSpan={3}>
                        {`Stan liczników wody (w m³)`}
                    </td>
                </tr>            
                <tr>
                    <td>
                        Stan początkowy
                    </td>
                    <td>
                        Stan bieżący
                    </td>
                    <td>
                        Zużycie
                    </td>
                </tr>
                <tr>
                    <td>
                        zimna woda
                    </td>
                    <td>{odczyty?.zimna_stan_poczatek}</td>
                    <td>{odczyty?.zimna_stan_koniec}</td>
                    <td >
                        { zaokr(procent?.zuzycieMieszkancaZimna,2) }
                    </td>
                </tr>
                <tr>
                    <td>
                        ciepła woda
                    </td>
                    <td>{odczyty?.ciepla_stan_poczatek}</td>
                    <td>{odczyty?.ciepla_stan_koniec}</td>
                    <td >
                        { procent?.zuzycieMieszkancaCiepla }
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default MieszkaniecDaneWodaRozliczenieStany;